/**
 * The header chip for a described scenario, where a loaded scenario's chip would sit: it
 * names the type the run carries, and holding the pointer on it shows the type whole.
 */

import { PenLine } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { DescribedScenarioType } from '@/services/ai-function.service';
import { ScenarioTypeLines } from '../session/scenario-type-peek';
import { DescribedBadge } from './described-badge';

const PEEK_DELAY_MS = 500;

export const DescribedScenarioChip = ({ scenarioType }: { scenarioType: DescribedScenarioType }) => (
  <Tooltip delayDuration={PEEK_DELAY_MS}>
    <TooltipTrigger asChild>
      <span className='flex max-w-88 items-center gap-1.5 rounded-full border border-teal-200 bg-teal-50 px-3 py-1.5 text-xs font-medium text-teal-700 animate-in fade-in-0 slide-in-from-top-1 duration-500'>
        <PenLine className='size-3.5 shrink-0' />
        <span className='shrink-0 font-semibold'>Scenario</span>
        <span aria-hidden='true' className='h-3 w-px shrink-0 bg-teal-200' />
        <span className='truncate font-normal'>{scenarioType.description}</span>
        <DescribedBadge />
      </span>
    </TooltipTrigger>
    <TooltipContent side='bottom' align='start' className='max-w-none p-3'>
      <ScenarioTypeLines description={scenarioType.description} outcome={scenarioType.outcome} tools={scenarioType.tools} />
    </TooltipContent>
  </Tooltip>
);
